// A verdict with no payload explains why in its message (already sent, not set up, or what would be refused).
export const NO_PAYLOAD_MESSAGE = 'No payload to show — see the message above.';
